export default __webpack_public_path__ + "static/pem-end-date-track-503dfaf96f51b04c9ce6b72223583cba.mp4";